import ManageModeAdministration from '@/views/parametres/mode-administration/manage-mode-administration'

export default {
    name: 'mode-administration',
    components: {
        ManageModeAdministration
    },
    props: [],
    data() {
        return {
            perPage: 20,
			currentPage: 1,
            fields: [
				{ key: 'libelle', label: 'Libellé' }, 'actions'
			],
			filter: "",
            mode_is_loading: true,
            mode_is_empty: false,
            modal_title: 'Nouveau',
            is_printing: false,

            selected_mode: {}
        }
    },

    computed: {
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        liste_mode_administration() {
            return this.$store.getters['liste_mode_administration'];
        },
    },

    mounted() {
        this.getModeAdministration()
    },

    methods: {
        getModeAdministration() {
            this.mode_is_loading = true

            this.$store.dispatch('getListeModeAdministration').then(() => {
                if (this.liste_mode_administration.length == 0) {
                    this.mode_is_empty = true
                } else {
                    this.mode_is_empty = false
                }
                this.mode_is_loading = false
            })
        },

        addModeAdministration(data) {
            if (data === 0) {
                this.selected_mode = {
                    id: 0,
                    designation: ''
                }
                return
            }
            this.selected_mode = {
                id: data.id,
                designation: data.designation
            }

            console.log(this.selected_mode);
        },

        setModeToDelete(data) {
            this.selected_mode = {
                id: data.id,
                designation: data.designation
            }
        }
    }
}